import { createConfig, lazyRoute } from "../config/config-utils"
import { WHEN } from "../config/constants"

const WriteCodeApp = lazyRoute(()=> import("./WriteCodeApp"), "WriteCodeApp")

export const WRITE_CODE_CONFIG = createConfig({
  component: WriteCodeApp,
  key: "write-code",
  label: "Write Code",
  mobile: false,
  when: WHEN,
})
